import moment from "moment";
import React from "react";
import { Image } from "react-bootstrap";
import { PAYMENT_STATUS, PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";
import { PAYMENT_STATUS_BADGE } from "../../../../enums/StatusBadges";
import ViewRsvpOfflineEvent from "../../../vendorDashboardComponents/events/OfflineEventDetails/OfflineEventTable/ViewRsvpOfflineEvent";

function TableHeadEvents(props) {
  return (
    <tr>
      <th style={{ width: "10%" }}>
        <div className="f12-400">Transaction ID</div>
      </th>
      {/* <th style={{ width: "15%" }}>
        <div className="f12-400">
          Business Name
          <br />
          /Location
        </div>
      </th> */}
      <th style={{ width: "15%" }}>
        <div className="f12-400">User Name</div>
      </th>
      <th style={{ width: "15%" }}>
        <div className="f12-400">
          Experience Name/ID/ <br />
          Experience Type
        </div>
      </th>
      <th style={{ width: "12%" }}>
        <div className="f12-400">
          Total PAX/
          <br /> Experience request ID
        </div>
      </th>
      <th style={{ width: "15%" }}>
        <div className="f12-400">
          Payment Method/ <br />
          Payment Status
        </div>
      </th>
      <th style={{ width: "10%" }}>
        <div className="f12-400">Date & Time</div>
      </th>
      <th style={{ width: "10%" }}>
        <div className="f12-400">Amount</div>
      </th>
    </tr>
  );
}

export default TableHeadEvents;

export const TableBodyEvents = (props) => {
  const data = props.data;
  const totalpaxvalue = () => {
    let value = 0;
    if (data?.expRequestId?.package?.count < 1) {
      value = ((data?.expRequestId?.adultCount || 0) + (data?.expRequestId?.kidsCount || 0));
      return value
    } else {
      value = ((data?.expRequestId?.adultCount || 0) + (data?.expRequestId?.kidsCount || 0)) + ((data?.expRequestId?.package?.adults + data?.expRequestId?.package?.kids) * data?.expRequestId?.package?.count)
      return value
    }
  }

  return (
    // props.data &&
    // props.data.slice(props.start, props.end).map((data, index) => {
    // return (
    <tbody
      // key={index}
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", wordBreak: "break-word" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
              >
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {data?.transactionNumber || data?._id}
                  </div>
                </td>

                <td style={{ width: "15%" }} className="text-center">
                  <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                    <div className="super-admin-suggestion-imageBoxTwo ml-2">
                      <div className="f12-400">
                        {data?.user_id?.first_name} {data?.user_id?.last_name}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="d-flex">
                    <div>
                      <img
                        src={data?.expRequestId?.experienceId?.photoThumbnails?.length ? data?.expRequestId?.experienceId?.photoThumbnails[0] : NOTAVAILABLEIMAGE}
                        width="35px"
                      />
                    </div>
                    <div>
                      <div className="f12-500">
                        {data?.expRequestId?.experienceId?.name}
                      </div>
                      <div className="f10-400">
                        {data?.expRequestId?.experienceId?.expId}
                      </div>
                      <div className="f10-500">
                        {data?.expRequestId?.expType}
                      </div>
                    </div>
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <p className="font_24_b">  {((data?.expRequestId?.adultCount || 0) + (data?.expRequestId?.kidsCount || 0)) + ((data?.expRequestId?.package?.adults + data?.expRequestId?.package?.kids) * data?.expRequestId?.package?.count)}</p>
                  <div className="f12-500">
                    {data?.expRequestId?.requestId}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {data?.orderId?.splitPayment ? (
                      <>Split Payment</>
                    ) : (
                      data?.payment_method
                    )}
                  </div>
                  <div
                    className={`badge badge-${data?.status === "captured" ? "success" : "warning"
                      }`}
                  >
                    {data?.status === "captured" ? "Success" : "Pending"}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {moment(data?.createdAt).format("ll")}
                    <br />
                    {moment(data?.createdAt).format("LT")}
                  </div>
                </td>
                <td style={{ width: "5%" }}>
                  <div className="f12-500">₹ {data?.amount}</div>
                </td>
                {/* <td style={{ width: "5%" }}>
                  <ViewRsvpOfflineEvent
                    dataSend={data?.event_request_id}
                    pathname="/offline-events-rsvp"
                    admin
                    dataProps={data?.event_request_id?.event_id}
                    defaultOpen={false}
                    setOpenFalse={() => {}}
                  />
                </td> */}
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
  // })
  // );
};
